import React from 'react';
import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { isLessThanBreakpoint } from 'dpl/util/grid';
import { breedRelationsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import HorizontalSlider from 'dpl/components/HorizontalSlider';
import SmartImage from 'dpl/components/SmartImage';
import SmartLink from 'dpl/components/SmartLink';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import Icon from 'dpl/common/components/Icon';

const IS_LT_LG = isLessThanBreakpoint('lg');
const IS_LT_XL = isLessThanBreakpoint('xl');
const ICON_WIDTH = IS_LT_LG ? '24px' : '30px';

let IMAGE_WIDTH;
if (IS_LT_LG) {
  IMAGE_WIDTH = '256px';
} else if (IS_LT_XL) {
  IMAGE_WIDTH = '388px';
} else {
  IMAGE_WIDTH = '426px';
}

export default function RelatedBreedsList() {
  const { breedData } = useSelector(({ server }) => server);

  const breedRelationsData = useResourceQuery(
    breedRelationsResourceDefinition(breedData.id)
  );

  if (!breedRelationsData.value.data.length) {
    return null;
  }

  return (
    <div className="RelatedBreedsList row ph5 pt10 ph20-md">
      <div className="col-12">
        <h2 className="mb4 mb12-md f6 f8-md lh-title">Related Breeds</h2>
        <HorizontalSlider
          iconClassName="b bg-white ph3 pv3 br-100 box-shadow-strong"
          arrowClassName="pb1"
          persistentArrows
          containerClassName="right-bleeding-row row flex-nowrap"
        >
          {breedRelationsData.value.data.map((breed, idx) => {
            const {
              availability_count_text: availabilityCountText,
              breed_overview_page_url: breedOverviewPageUrl,
              id,
              name,
              pluralized_breed_name: pluralizedBreedName,
              secondary_photo_url: secondaryPhotoUrl,
              standard_color_text: standardColorText,
              url
            } = breed;

            return (
              <div className="mb4 mb0-lg relative ph3 no-outline" key={idx}>
                <SmartLink to={url}>
                  <div className="mb4 br1 overflow-hidden">
                    <div className="transition grow f0 br1 overflow-hidden">
                      <SmartImage
                        Tag="div"
                        crop
                        className="zoom cover"
                        height={IMAGE_WIDTH}
                        src={secondaryPhotoUrl}
                        width={IMAGE_WIDTH}
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <h5 className="mb1 mb0-lg f2 f3-sm f4-lg fw-medium flex-auto w0 ws-normal">
                      {name}
                    </h5>
                    {breedData.id === id && (
                      <TooltipWrapper
                        className="lh-1 v-mid"
                        minWidth="300px"
                        title={
                          // eslint-disable-next-line react/no-danger
                          <p
                            dangerouslySetInnerHTML={{
                              __html: standardColorText
                            }}
                          />
                        }
                      >
                        <Icon
                          name="help"
                          width={ICON_WIDTH}
                          height={ICON_WIDTH}
                        />
                      </TooltipWrapper>
                    )}
                  </div>
                  {!window.__DPL_BOT_UA && (
                    <p className="mb1 mb0-lg f2">{availabilityCountText}</p>
                  )}
                </SmartLink>
                {breedOverviewPageUrl && (
                  <a
                    className="mb1 mb0-lg f2 fw-medium stone-700 ws-normal"
                    href={breedOverviewPageUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn about {pluralizedBreedName}
                  </a>
                )}
              </div>
            );
          })}
        </HorizontalSlider>
      </div>
    </div>
  );
}
